import { Head, Link } from 'zudoku/components';

/** French 404, with the three places a lost reader most likely wanted. */
export const NotFound = () => (
  <section className="flex items-center justify-center py-20 px-4" data-pagefind-ignore="all">
    <Head>
      <title>Page introuvable</title>
    </Head>
    <div className="text-center max-w-lg mx-auto">
      <p className="text-6xl font-extrabold text-primary mb-4 noe-heading">404</p>
      <h1 className="text-3xl font-bold mb-4 noe-heading">Cette page n’existe pas</h1>
      <p className="text-muted-foreground mb-8">
        Elle a peut-être été déplacée. Utilisez la recherche en haut de la page, ou repartez de
        l’une de ces rubriques.
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center rounded-full bg-primary px-5 h-10 text-sm font-semibold text-primary-foreground"
        >
          Accueil du centre d’aide
        </Link>
        <Link
          to="/site-de-reservation"
          className="inline-flex items-center rounded-full border px-5 h-10 text-sm font-semibold hover:bg-accent"
        >
          Site de réservation
        </Link>
        <Link
          to="/guide"
          className="inline-flex items-center rounded-full border px-5 h-10 text-sm font-semibold hover:bg-accent"
        >
          Guide d’utilisation
        </Link>
      </div>
    </div>
  </section>
);
